import { createAction, props } from '@ngrx/store';

export const loadAddPaymentDay = createAction(
  '[AddPaymentDay] Load AddPaymentDays',
  props<{ request: { businessId: string; paymentDay: number } }>()
);

export const loadAddPaymentDaySuccess = createAction('[AddPaymentDay] Load AddPaymentDays Success', props<{ response: string }>());

export const loadAddPaymentDayFailure = createAction('[AddPaymentDay] Load AddPaymentDays Failure', props<{ error: Error | any }>());
